import React from 'react'
import CreateKitchen from '../../../components/organisms/admin/kitchen/CreateKitchen'

type Props = {}

const CreateKitchenPage = (props: Props) => {

  return (
    <CreateKitchen />
  )
}

export default CreateKitchenPage